// frontend/src/components/Bottombar/index.tsx
import React from "react";
import { Link } from "react-router-dom";
import styles from "./Bottombar.module.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEnvelope, faQuoteLeft } from "@fortawesome/free-solid-svg-icons";
import {
  faFacebookF,
  faTwitter,
  faInstagram,
  faLinkedinIn,
} from "@fortawesome/free-brands-svg-icons";

const BottomBar = () => {
  return (
    <>
      {/* Desktop Footer */}
      <footer className={styles["desktop-footer"]}>
        <div className={styles["footer-container"]}>
          <div className={styles["footer-row"]}>
            {/* About Section */}
            <div className={styles["footer-col"]}>
              <FontAwesomeIcon
                icon={faQuoteLeft}
                className={styles["footer-icon"]}
              />
              <span className={styles["footer-about-text"]}>
                "Crafting premium commercial furniture solutions that blend
                durability, functionality, and contemporary design for
                businesses and institutions."
              </span>
              <div className={styles["footer-social"]}>
                <a href="#" className={styles["social-icon"]}>
                  <FontAwesomeIcon icon={faFacebookF} />
                </a>
                <a href="#" className={styles["social-icon"]}>
                  <FontAwesomeIcon icon={faInstagram} />
                </a>
                <a href="#" className={styles["social-icon"]}>
                  <FontAwesomeIcon icon={faLinkedinIn} />
                </a>
                <a href="#" className={styles["social-icon"]}>
                  <FontAwesomeIcon icon={faTwitter} />
                </a>
              </div>
            </div>

            {/* Quick Links */}
            <div className={styles["footer-col"]}>
              <p className={styles["footer-title"]}>Explore</p>
              <ul className={styles["footer-links"]}>
                <li>
                  <Link to="/">Home</Link>
                </li>
                <li>
                  <Link to="/gallery">Product Gallery</Link>
                </li>
                <li>
                  <Link to="/contact">Contact Us</Link>
                </li>
                <li>
                  <Link to="/contact">Request Quote</Link>
                </li>
                <li>
                  <Link to="/contact">Bulk Orders</Link>
                </li>
              </ul>
            </div>

            {/* Product Series */}
            <div className={styles["footer-col"]}>
              <p className={styles["footer-title"]}>Our Series</p>
              <ul className={styles["footer-links"]}>
                <li>Executive Series</li>
                <li>Director Series</li>
                <li>Cafeteria Series</li>
                <li>Office Table Series</li>
                <li>Visitor Series</li>
              </ul>
            </div>

            {/* Contact Info */}
            <div className={styles["footer-col"]}>
              <p className={styles["footer-title"]}>Get In Touch</p>
              <ul className={styles["footer-contact"]}>
                <li>
                  <FontAwesomeIcon
                    icon={faEnvelope}
                    className={styles["contact-icon"]}
                  />
                  <span>sales@scadelfurnitures.com</span>
                </li>
                <li className={styles["footer-cta"]}>
                  <Link to="/contact" className={styles["cta-button"]}>
                    Request Catalog
                  </Link>
                </li>
              </ul>
            </div>
          </div>
          <div className={styles["copyright"]}>
            © {new Date().getFullYear()} SCADEL FURNITURES. All Rights Reserved.
          </div>
        </div>
      </footer>
    </>
  );
};

export default BottomBar;
